// Phase 5.1 — Customers screen, migrated to shadcn/Tailwind.
//
// UI only: the MUI Table, the ApparelSubmenu toolbar, the antd Drawer add/edit
// Form and the MUI TreeView purchase-history Drawer are replaced by the shared
// DataTable (CustomerTable) + PageHeader + built-in search/sort/pagination, a
// Sheet (AddCustomerSheet) and a Sheet+Accordion (PurchaseHistorySheet). Every
// dispatch / useSelector / payload is unchanged — the handlers below are the
// legacy ones (getCustomerListAction / createCustomerAction /
// getCustomerHistoryAction). The antd Form is dropped: inputs are controlled by
// `addCustomerValue` (which the antd fields mirrored), so `form.setFieldsValue`
// calls are removed; validators ported into AddCustomerSheet's `validate()`.
import AppConstant from "../Globals/AppConstants"
import ApparelMenu from "./SubComponents/apparelMenu"
import { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "sonner";
import {
    createCustomerAction, getCustomerHistoryAction, getCustomerListAction, getUpcomingCustomerEventsAction, mergeCustomerAction,
    setCustomerCreditLimitAction, addCustomerCreditOpeningBalanceAction,
} from "../Store/actions/apparelAction";
import { deepCopyFunction } from "../Utils/helpers";
import { getUser } from "../Utils/localStorage";
import { LoadingOverlay } from "../shared/loading-overlay";
import { Button } from "ui/button";
import CustomerTable from "./users/CustomerTable";
import AddCustomerSheet from "./users/AddCustomerSheet";
import MergeCustomerDialog from "./users/MergeCustomerDialog";
import PurchaseHistorySheet from "./users/PurchaseHistorySheet";

const Customer = () => {
    const [open, setOpen] = useState(false);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const location = useLocation();
    // Arriving from Audit Log: re-run this screen's own search with the
    // record's business code (customerCode), then open its Edit sheet once
    // the matching row (by customerDetailId, the uniqueKey alias) shows up
    // in the list — same pattern as employee.tsx.
    const [pendingAuditRecordId, setPendingAuditRecordId] = useState<string | undefined>(location.state?.auditRecordId);
    const apparelReducerState: any = useSelector((state: any) => state.ApparelReducerState);
    const {
        customerListData, createCustomerOnload, getCustomerHistoryData, customerListOnload, createCustomerData, mergeCustomerOnload, mergeCustomerData,
        setCustomerCreditLimitOnload, setCustomerCreditLimitData,
        addCustomerCreditOpeningBalanceOnload, addCustomerCreditOpeningBalanceData,
    } = apparelReducerState;
    const customerList = customerListData?.getCustomerList?.customerDetails;
    const customerListPage = customerListData?.getCustomerList?.page;
    const customerPurchaseHistory = getCustomerHistoryData?.getCustomerHistory?.rows;

    const [addCustomerOnload, setAddCustomerOnload] = useState(false);
    const [page] = useState(1);
    const [validation, setValidation] = useState(false);
    const [customerEdit, setCustomerEdit] = useState<any>(null);
    const [numberExists, setnumberExists] = useState<any>(null);
    const [customerMerge, setCustomerMerge] = useState<any>(null);
    const [mergeSearchText, setMergeSearchText] = useState("");
    const [mergeSubmitted, setMergeSubmitted] = useState(false);
    const searchtemp: any = {
        searchText: "",
        offset: 0,
        limit: 10,
        page: 1,
        sortBy: "0",
        // "" = All, "0"/"1" = WhatsApp Group Joined filter, "not_whatsapp" =
        // Not a WhatsApp Number filter — one combined dropdown.
        whatsappGroupStatus: ""
    };
    const [filterData, setFilterData] = useState<any>(deepCopyFunction(searchtemp));

    const getsearchTextdataList = (searchText: any) => {
        setFilterData({ ...filterData, searchText: searchText, offset: 0, page: 1 });
    }
    const getSortOrder = (sortBy: any) => {
        setFilterData({ ...filterData, sortBy: sortBy, offset: 0, page: 1 });
    }
    const getWhatsappFilterChange = (whatsappGroupStatus: any) => {
        setFilterData({ ...filterData, whatsappGroupStatus: whatsappGroupStatus, offset: 0, page: 1 });
    }

    const getCustomerListApi = () => {
        let payload = {
            searchText: filterData?.searchText,
            sortBy: filterData?.sortBy,
            // "not_whatsapp" filters by its own flag instead of
            // whatsappGroupStatus — the two are mutually exclusive in the UI.
            whatsappGroupStatus: filterData?.whatsappGroupStatus === "" || filterData?.whatsappGroupStatus === "not_whatsapp"
                ? null : Number(filterData?.whatsappGroupStatus),
            isNotWhatsappNumber: filterData?.whatsappGroupStatus === "not_whatsapp" ? 1 : null,
            // Sort id "8" is the "Outstanding (High -> Low)" option — that only
            // orders by creditBalance, so customers with no balance still show
            // up (sorted last). Pair it with the backend's hasOutstanding
            // filter so picking it actually excludes those customers.
            hasOutstanding: String(filterData?.sortBy) === "8",
            limit: 10,
            offset: filterData?.offset
        }
        dispatch(getCustomerListAction(payload));
    }

    const handlePagination = (page: any, offset: any) => {
        setFilterData({ ...filterData, offset: offset, page: page })
    }

    // DataTable gives a 1-based page; translate to the legacy offset math.
    const onPageChange = (nextPage: number) => {
        let offset = ((nextPage * 10) - 10 === 0) ? 0 : (nextPage * 10) - 10;
        handlePagination(page, offset);
    }

    useEffect(() => {
        if (filterData) {
            getCustomerListApi()
        }
    }, [filterData])

    useEffect(() => {
        if (location.state?.auditSearchCode) {
            setFilterData((s: any) => ({ ...s, searchText: location.state.auditSearchCode, offset: 0, page: 1 }));
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [])

    useEffect(() => {
        if (!pendingAuditRecordId || !customerList?.length) return;
        const match = customerList.find((c: any) => c?.customerDetailId === pendingAuditRecordId);
        if (match) {
            setCustomerEdit(match);
            setPendingAuditRecordId(undefined);
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [pendingAuditRecordId, customerList])

    const customerTemp = {
        customerId: "",
        customerName: "",
        mobileNumber: "",
        dateOfBirth: null as any,
        weddingAnniversary: null as any,
        whatsappGroupStatus: 0,
        isNotWhatsappNumber: 0
    }
    const [addCustomerValue, setAddCustomerValue] = useState<any>(deepCopyFunction(customerTemp));

    const isAdmin = getUser()?.roleId == 1;

    // One global Save now covers the customer's own fields plus (edit mode,
    // admin only) Credit Limit and Opening Balance — there used to be a
    // separate Save/Record button per Credit field; those mutations are
    // still their own dispatches (setCustomerCreditLimit/
    // addCustomerCreditOpeningBalance stay independent from saveCustomer),
    // just fired together from this one click instead of three.
    const createCustomerApi = () => {
        if (addCustomerValue?.customerName == "" || addCustomerValue?.mobileNumber == "") {
            setValidation(true)
        }
        else {
            let payload = {
                customerId: addCustomerValue?.customerId ? addCustomerValue?.customerId : "",
                customerName: addCustomerValue?.customerName,
                mobileNumber: (customerEdit && addCustomerValue?.mobileNumber.toLowerCase() == "nil") ? customerEdit?.mobileNumber : addCustomerValue?.mobileNumber,
                dateOfBirth: addCustomerValue?.dateOfBirth || null,
                weddingAnniversary: addCustomerValue?.weddingAnniversary || null,
                whatsappGroupStatus: addCustomerValue?.whatsappGroupStatus ?? 0,
                isNotWhatsappNumber: addCustomerValue?.isNotWhatsappNumber ?? 0
            }
            dispatch(createCustomerAction(payload))
            setAddCustomerOnload(true);

            if (customerEdit && isAdmin) {
                const currentCreditLimit = customerEdit?.creditLimit != null ? Number(customerEdit.creditLimit) : 0;
                const nextCreditLimit = Number(creditLimitInput) || 0;
                if (nextCreditLimit !== currentCreditLimit) {
                    dispatch(setCustomerCreditLimitAction({ customerId: addCustomerValue.customerId, creditLimit: nextCreditLimit }));
                    setCreditLimitSubmitted(true);
                }
                if (!customerEdit?.hasCreditLedgerEntries && openingBalanceAmount && Number(openingBalanceAmount) > 0) {
                    dispatch(addCustomerCreditOpeningBalanceAction({
                        customerId: addCustomerValue.customerId,
                        amount: Number(openingBalanceAmount),
                        remarks: openingBalanceRemarks,
                    }));
                    setOpeningBalanceSubmitted(true);
                }
            }
        }
    }
    const [customerHistory, setCustomerHistory] = useState<any>();
    const getCustomerHistoryApi = (data: any) => {
        let payload = {
            customerId: data?.customerDetailId
        }

        dispatch(getCustomerHistoryAction(payload))
        setCustomerHistory(data);
        setPurchaseHistoryOpen(true)
    }

    useEffect(() => {
        if (createCustomerOnload == false && addCustomerOnload == true) {
            if (typeof createCustomerData?.data?.saveCustomer === 'object') {
                setAddCustomerValue(deepCopyFunction(customerTemp))
                getCustomerListApi()
                // Refresh the topbar's DOB/anniversary notification immediately —
                // otherwise a newly added/edited date only shows up after the
                // next route change (its own re-fetch effect) or a page reload.
                dispatch(getUpcomingCustomerEventsAction({ limit: 10 }))
                toast.success(customerEdit ? "Customer updated successfully" : "Customer added successfully")
                setOpen(false)
                setAddCustomerOnload(false)
                setCustomerEdit(null)
            }
            else {
                setnumberExists(createCustomerData?.data?.saveCustomer)
                toast.error(createCustomerData?.data?.saveCustomer)
            }
        }
    }, [createCustomerOnload, addCustomerOnload])

    useEffect(() => {
        if (customerEdit) {
            setOpen(true)
            prePopulateForEdit()
        }
    }, [customerEdit])

    const prePopulateForEdit = () => {
        setAddCustomerValue({
            customerId: customerEdit?.customerDetailId,
            customerName: customerEdit?.customerName,
            mobileNumber: customerEdit?.mobileNumber,
            dateOfBirth: customerEdit?.dateOfBirth ?? null,
            weddingAnniversary: customerEdit?.weddingAnniversary ?? null,
            whatsappGroupStatus: customerEdit?.whatsappGroupStatus ?? 0,
            isNotWhatsappNumber: customerEdit?.isNotWhatsappNumber ?? 0
        })
        setCreditLimitInput(customerEdit?.creditLimit != null ? String(Number(customerEdit.creditLimit)) : "0")
        setOpeningBalanceAmount("")
        setOpeningBalanceRemarks("")
    }

    // Customer Credit — Credit Limit / Opening Balance, admin-only fields on the
    // same Add/Edit sheet (see AddCustomerSheet's Credit section).
    const [creditLimitInput, setCreditLimitInput] = useState("0");
    const [openingBalanceAmount, setOpeningBalanceAmount] = useState("");
    const [openingBalanceRemarks, setOpeningBalanceRemarks] = useState("");
    const [creditLimitSubmitted, setCreditLimitSubmitted] = useState(false);
    const [openingBalanceSubmitted, setOpeningBalanceSubmitted] = useState(false);

    useEffect(() => {
        if (setCustomerCreditLimitOnload == false && creditLimitSubmitted == true) {
            setCreditLimitSubmitted(false);
            const result = setCustomerCreditLimitData?.data?.setCustomerCreditLimit;
            if (result === "Updated Successfully") {
                toast.success("Credit limit updated");
                // customerEdit (what prePopulateForEdit reads creditLimit from)
                // is never refreshed by getCustomerListApi() below — it only
                // refetches the background list. Without this, the NEXT
                // customerEdit patch (e.g. Record Opening Balance's own
                // success handler) re-runs prePopulateForEdit and stomps the
                // just-saved limit back to whatever stale value the sheet
                // opened with, showing 0 until a full page refresh.
                setCustomerEdit((prev: any) => prev ? { ...prev, creditLimit: Number(creditLimitInput) || 0 } : prev);
                getCustomerListApi();
            } else {
                toast.error(result || "Failed to update credit limit");
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [setCustomerCreditLimitOnload, creditLimitSubmitted])

    useEffect(() => {
        if (addCustomerCreditOpeningBalanceOnload == false && openingBalanceSubmitted == true) {
            setOpeningBalanceSubmitted(false);
            const result = addCustomerCreditOpeningBalanceData?.data?.addCustomerCreditOpeningBalance;
            if (result === "Updated Successfully") {
                toast.success("Opening balance recorded");
                // Same staleness issue as setCustomerCreditLimit above —
                // patch creditBalance here too (Opening Balance is always the
                // customer's first-ever ledger entry, so newBalance is
                // exactly the submitted amount) so this doesn't get
                // overwritten back to its pre-edit value on the next
                // customerEdit-triggered prePopulateForEdit() run.
                setCustomerEdit((prev: any) => prev ? { ...prev, openingBalanceRecorded: true, hasCreditLedgerEntries: true, creditBalance: Number(openingBalanceAmount) || 0 } : prev);
                setOpeningBalanceAmount("");
                setOpeningBalanceRemarks("");
                getCustomerListApi();
            } else {
                toast.error(result || "Failed to record opening balance");
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [addCustomerCreditOpeningBalanceOnload, openingBalanceSubmitted])

    const [purchaseHistoryOpen, setPurchaseHistoryOpen] = useState(false);

    const clearValidationAndClose = () => {
        setAddCustomerValue(deepCopyFunction(customerTemp))
        setValidation(false)
        setOpen(false)
        setCustomerEdit(null)
        setnumberExists(null)
    }

    const [mergeSearching, setMergeSearching] = useState(false);

    const openMerge = (item: any) => {
        setCustomerMerge(item);
        setMergeSearchText("");
        setMergeSearching(false);
    }

    const handleMergeSearch = (searchText: string) => {
        setMergeSearchText(searchText);
    }

    // Debounced, and only once the user has typed something — the merge
    // picker must never repeat the unbounded (limit: 0) fetch the main table
    // uses, which runs 4 correlated per-row subqueries across every
    // non-deleted customer (thousands of rows) and freezes the page.
    useEffect(() => {
        if (!customerMerge) return;
        const trimmed = mergeSearchText.trim();
        if (trimmed.length < 2) {
            setMergeSearching(false);
            return;
        }
        setMergeSearching(true);
        const timer = setTimeout(() => {
            dispatch(getCustomerListAction({ searchText: trimmed, sortBy: 0, limit: 20, offset: 0 }));
        }, 300);
        // Safety net: getCustomerListSaga's error path never resets
        // customerListOnload, so a failed/timed-out request would otherwise
        // leave the dialog stuck on "Searching..." forever. Local state is
        // used instead of the shared customerListOnload flag so this can
        // always be force-cleared.
        const giveUp = setTimeout(() => setMergeSearching(false), 8000);
        return () => { clearTimeout(timer); clearTimeout(giveUp); }
    }, [customerMerge, mergeSearchText])

    // customerListData gets a new object reference on every successful
    // getCustomerList response (main table, billing search, or this merge
    // search alike) — used here purely as a "a request just resolved" signal
    // to clear the local loading flag.
    useEffect(() => {
        if (mergeSearching) setMergeSearching(false);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [customerListData])

    const closeMergeDialog = () => {
        setCustomerMerge(null);
        setMergeSearchText("");
        getCustomerListApi();
    }

    const confirmMergeCustomer = (targetCustomerId: string) => {
        dispatch(mergeCustomerAction({
            sourceCustomerId: customerMerge?.customerDetailId,
            targetCustomerId
        }));
        setMergeSubmitted(true);
    }

    useEffect(() => {
        if (mergeCustomerOnload == false && mergeSubmitted == true) {
            setMergeSubmitted(false);
            if (mergeCustomerData?.data?.mergeCustomer === "Updated Successfully") {
                toast.success("Customer merged successfully");
            } else {
                toast.error(mergeCustomerData?.data?.mergeCustomer || "Failed to merge customer");
            }
            closeMergeDialog();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [mergeCustomerOnload, mergeSubmitted])

    return (
        <div className="mz h-full overflow-y-auto px-6 py-4">
            <ApparelMenu selectedKey="3" />
            <CustomerTable
                data={customerList}
                loading={customerListOnload}
                onViewHistory={getCustomerHistoryApi}
                onEdit={setCustomerEdit}
                onMerge={openMerge}
                whatsappFilter={filterData?.whatsappGroupStatus}
                onWhatsappFilterChange={getWhatsappFilterChange}
                onViewCredit={(item: any) => navigate(`/credit-ledger/${item?.customerDetailId}`)}
                onViewFeedback={(item: any) => navigate(`/feedback/list`, { state: { customerDetailId: item?.customerDetailId, customerName: item?.customerName } })}
                searchValue={filterData?.searchText}
                onSearch={getsearchTextdataList}
                searchPlaceholder={"Search By Customer Name/Mobile Number/ID"}
                sortBy={filterData?.sortBy}
                onSortChange={getSortOrder}
                title="Customers"
                headerActions={<Button onClick={() => setOpen(true)}>{AppConstant?.add}</Button>}
                pagination={{
                    page: customerListPage?.currentPage || 1,
                    total: customerListPage?.totalCount || 0,
                    onChange: onPageChange,
                }}
            />
            <AddCustomerSheet
                open={open}
                onClose={clearValidationAndClose}
                isEdit={!!customerEdit}
                formData={addCustomerValue}
                numberExists={numberExists}
                saving={createCustomerOnload || creditLimitSubmitted || openingBalanceSubmitted}
                onChange={(patch: any) => { setAddCustomerValue({ ...addCustomerValue, ...patch }); setnumberExists(null); }}
                onSubmit={createCustomerApi}
                creditLimitInput={creditLimitInput}
                onCreditLimitChange={setCreditLimitInput}
                hasCreditLedgerEntries={!!customerEdit?.hasCreditLedgerEntries}
                openingBalanceAmount={openingBalanceAmount}
                onOpeningBalanceAmountChange={setOpeningBalanceAmount}
                openingBalanceRemarks={openingBalanceRemarks}
                onOpeningBalanceRemarksChange={setOpeningBalanceRemarks}
                onViewCreditLedger={customerEdit?.customerDetailId ? () => navigate(`/credit-ledger/${customerEdit.customerDetailId}`) : undefined}
            />
            {customerMerge && (
                <MergeCustomerDialog
                    open={!!customerMerge}
                    onClose={closeMergeDialog}
                    sourceCustomer={customerMerge}
                    candidates={customerList || []}
                    loading={mergeSearching}
                    merging={mergeCustomerOnload}
                    searchValue={mergeSearchText}
                    onSearch={handleMergeSearch}
                    onConfirmMerge={confirmMergeCustomer}
                />
            )}
            <PurchaseHistorySheet
                open={purchaseHistoryOpen}
                onClose={() => setPurchaseHistoryOpen(false)}
                title={customerHistory?.customerName}
                subtitle={customerHistory?.mobileNumberList}
                resetKey={customerHistory?.customerDetailId}
                yearCount={4}
                historyByDate={customerPurchaseHistory}
                getItemInvoiceId={(item: any) => item?.invoiceId}
                getItemAmount={(item: any) => Number(item?.invoiceTotalAmount) || 0}
                renderItem={(item1: any, idx: number) => (
                    <div key={idx} className="flex items-start justify-between gap-3 rounded-lg border p-3">
                        <div className="min-w-0">
                            <div className="truncate text-sm text-foreground">{item1?.invoiceId} - {item1?.productName}</div>
                            <div className="text-xs text-muted-foreground">{item1?.color} ({item1?.size})</div>
                        </div>
                        <div className="whitespace-nowrap text-sm tabular-nums">₹{item1?.mrp}/-</div>
                    </div>
                )}
            />
            <LoadingOverlay loading={createCustomerOnload} />
        </div>
    )
}

export default Customer;
